import client from './client';
import qs from 'qs';

const approvalUrl = '/api/v1/common/approval';
const orderUrl = '/api/v1/project/orders';
const techUrl = '/api/v1/project/tech';
const taxUrl = '/api/v1/project/invoice';

//결재history
export const getApprovalHistory = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${approvalUrl}/history?${queryString}`);
};
// /history/{historyTyp} 2023.10.05
export const getApprovalHistoryByType = ({ type, searchData }) => {
  const queryString = qs.stringify(searchData.searchData);   
  return client.get(`${approvalUrl}/history/${type}?${queryString}`);
};

export const getApprovalMonitor = (searchData) => {
  const queryString = qs.stringify(searchData.searchData); 
  return client.get(`${approvalUrl}/now/all?${queryString}`);
};

//DOCU_CD의 현재 결재Doc 정보
export const getCurApprovalDetByCd = (id) => {
  return client.get(`${approvalUrl}/info/${id}`);
};

//결재정보 상세
export const getApproval = (id) => {
  return client.get(`${approvalUrl}/list/${id}`);
};

// 결재 삭제
export const deleteApproval = (id) => {
  return client.delete(`${approvalUrl}/info/${id}`);
};

//결재정보
export const addOrderDoc = (dataToSubmit) => {
  return client.post(
    `${orderUrl}/data/${dataToSubmit.docuCd}/approval/${dataToSubmit.docuUuid}`,
    dataToSubmit,
  );
};

export const addTechDoc = (dataToSubmit) => {
  return client.post(
    `${techUrl}/rslt/data/${dataToSubmit.docuCd}/approval/${dataToSubmit.docuUuid}`,
    dataToSubmit,
  );
};

//세금계산서
export const addTaxDoc = (dataToSubmit) => {
  return client.post(
    `${taxUrl}/issue/${dataToSubmit.docuCd}/approval/${dataToSubmit.docuUuid}`,
    dataToSubmit,
  );
};
